import React from 'react';
import t from 'react-translate';
import { useSelector } from 'react-redux';

// redux
import { getFlatCourseAliases } from 'redux/selectors/course';

import NvTextArea from 'shared/components/inputs/nv-text-area';
import {
  ReactComponent as AIContext,
} from 'styles/icons/ai-context.svg';
import { useLecturePageParams } from 'lecture_pages/hooks/lecture-routing';
import { doubleSpacing } from 'styles/global_defaults/scaffolding';
import ViewValidationError from 'quizzes/components/view-validation-error';
import { useFormContext } from 'react-hook-form';

const RolePlayContextSetting = () => {
  const params = useLecturePageParams();
  const courseAliases = useSelector(state => getFlatCourseAliases(state, params.catalogId));
  const { formState } = useFormContext();
  const showContextMaxCharLimitError = () => formState?.errors.context?.type === 'max';
  return (
    <div>
      <div className='d-flex flex-column'>
        <div className='d-flex justify-content-center mt-6'>
          <AIContext
            height={doubleSpacing}
            width={doubleSpacing}
          />
        </div>
        <p className='page-title mb-4 mt-2 mx-auto text-black lh-35'>
          {t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.MODAL.THE_CONTEXT()}
        </p>
        <p className='text-align-justify text-large-body lh-25'>
          {t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.MODAL.INSTRUCTION_LABEL(courseAliases)}
        </p>
      </div>
      <NvTextArea
        withForm
        name='context'
        className='border-gray-5 bg-white mt-2 required-textarea'
        textareaClassName='min-h-lg text-large-body lh-30'
        required
      />
      {showContextMaxCharLimitError() && (
        <ViewValidationError characterLimit='10,000' />
      )}
    </div>
  );
};

export default RolePlayContextSetting;
